import { BASE_URL } from '../utils/constants';

const getFreeTimes = (id, min) =>
  `${BASE_URL}/api/EventList/get_free_time/?med_id=${id}&min=${min}`;

export { getFreeTimes };
